import { createFileRoute } from '@tanstack/react-router';

import { useTranslation } from '@apple/lib/i18next';
import { useBackOrNavigate } from '@apple/lib/tanstack-router/hooks/use-router-history';
import { DetailsLayout } from '@apple/ui/layouts/DetailsLayout';
import { countryCodeSchema } from '@apple/utils/globalization/models';

import { requireAuth } from '@apple/features/auth/utils/require-auth';
import { MarketForm } from '@apple/features/market/components/MarketForm';
import { useMarketManagement } from '@apple/features/market/hooks/useMarketManagement';

export const Route = createFileRoute('/_authed/_admin/manage/markets_/add')({
	beforeLoad: ({ ...args }) => {
		requireAuth(args, {
			requirePermission: 'Manzanita.Security.Features.CustomerGroupManagement.Read',
		});
	},
	component: MarketRoute,
});

function MarketRoute() {
	const { t } = useTranslation('market');
	const goBackToList = useBackOrNavigate();
	const { mutateAsync } = useMarketManagement();

	return (
		<DetailsLayout title={t('title.add')}>
			<MarketForm
				isEdit={false}
				onSaveMarket={async market =>
					await mutateAsync(
						{
							action: 'add',
							market: {
								...market,
								countryCode: countryCodeSchema.parse(market.countryCode),
							},
						},
						{
							onSuccess: () => void goBackToList('/manage/markets'),
						},
					)
				}
			/>
		</DetailsLayout>
	);
}
